import { STEPS } from "../../data/content";
import { FadeUp, SectionHead, ChapterTag } from "./Reveal";

export default function HowWeWork() {
    return (
        <section className="bg-navy-deep py-24 lg:py-32" data-testid="how-we-work-section">
            <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                <ChapterTag>Chapter 03 &mdash; How We Work</ChapterTag>
                <SectionHead
                    className="mt-8"
                    eyebrow="Our Process"
                    title="Complex International Journeys, Made Clearer"
                />

                <div className="mt-14">
                    {STEPS.map((s, i) => (
                        <FadeUp key={s.n} delay={i * 0.08}>
                            <div
                                className="grid grid-cols-1 items-baseline gap-3 border-t border-white/10 py-9 transition-colors duration-500 hover:border-gold/30 md:grid-cols-12 md:gap-6"
                                data-testid={`step-${s.n}`}
                            >
                                <span className="font-serif text-6xl font-light leading-none text-outline-gold md:col-span-3 lg:text-7xl" aria-hidden="true">
                                    {s.n}
                                </span>
                                <h3 className="font-serif text-2xl font-normal text-ivory md:col-span-3 lg:text-3xl">
                                    {s.title}
                                </h3>
                                <p className="max-w-xl text-base leading-relaxed text-slate-300/80 md:col-span-6 md:justify-self-end">
                                    {s.copy}
                                </p>
                            </div>
                        </FadeUp>
                    ))}
                    <div className="border-t border-white/10" aria-hidden="true" />
                </div>
            </div>
        </section>
    );
}
